module.exports = __webpack_public_path__ + "media/images/product-img-01-68fe4629b271b51c710f742ba3a1f911.jpg";